import { Store } from 'src/store/index';

const getOrderItemId = (store: Store) => store.design.orderItemId;
export default getOrderItemId;
